import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin, Shield, Award } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1B365D] text-white" data-id="element-150">
      <div className="container mx-auto px-4 py-12" data-id="element-151">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-152">
          <div data-id="element-153">
            <div className="mb-4" data-id="element-154">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/71XGyHSaKA5S5uajSj7G8p/Crown_Logo_-_Edited_-_Edited.png" alt="Crown Inspection Services" className="h-16 w-auto" data-id="element-155" />
            </div>
            <p className="mb-4 text-gray-300" data-id="element-156">
              Southwest Florida's most trusted home inspection service,
              providing thorough inspections and detailed reports to protect
              your investment.
            </p>
            <div className="flex space-x-4" data-id="element-157">
              <a href="#" className="text-white hover:text-[#D4AF37]" data-id="element-158">
                <Facebook size={20} data-id="element-159" />
              </a>
              <a href="#" className="text-white hover:text-[#D4AF37]" data-id="element-160">
                <Instagram size={20} data-id="element-161" />
              </a>
              <a href="#" className="text-white hover:text-[#D4AF37]" data-id="element-162">
                <Linkedin size={20} data-id="element-163" />
              </a>
            </div>
          </div>
          <div data-id="element-164">
            <h3 className="text-lg font-bold mb-4 text-[#D4AF37]" data-id="element-165">
              Our Services
            </h3>
            <ul className="space-y-2" data-id="element-166">
              <li data-id="element-167">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-168">
                  Home Inspections
                </a>
              </li>
              <li data-id="element-169">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-170">
                  Wind Mitigation
                </a>
              </li>
              <li data-id="element-171">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-172">
                  4-Point Inspections
                </a>
              </li>
              <li data-id="element-173">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-174">
                  Roof Certificates
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-176">
                  Mold Inspections
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-177">
            <h3 className="text-lg font-bold mb-4 text-[#D4AF37]" data-id="element-178">Resources</h3>
            <ul className="space-y-2" data-id="element-179">
              <li data-id="element-180">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-181">
                  Inspection Guides
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-183">
                  Blog Articles
                </a>
              </li>
              <li data-id="element-184">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-185">
                  FAQ
                </a>
              </li>
              <li data-id="element-186">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-187">
                  Sample Reports
                </a>
              </li>
              <li data-id="element-188">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-189">
                  Insurance Discounts
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-190">
            <h3 className="text-lg font-bold mb-4 text-[#D4AF37]" data-id="element-191">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-192">
              <li className="flex items-start" data-id="element-193">
                <Phone size={18} className="mr-2 mt-1 text-[#D4AF37]" data-id="element-194" />
                <div data-id="element-195">
                  <a href="tel:2396997080" className="hover:underline" data-id="element-196">
                    239-699-7080
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-197">
                <Mail size={18} className="mr-2 mt-1 text-[#D4AF37]" data-id="element-198" />
                <div data-id="element-199">
                  <a href="mailto:Crowninspectionservices@gmail.com" className="hover:underline" data-id="element-200">
                    Crowninspectionservices@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-201">
                <MapPin size={18} className="mr-2 mt-1 text-[#D4AF37]" data-id="element-202" />
                <div data-id="element-203">
                  Fort Myers, FL
                  <div className="text-sm text-gray-400" data-id="element-204">
                    Serving all of SW Florida
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-700" data-id="element-205">
          <div className="flex flex-col md:flex-row md:justify-between items-center" data-id="element-206">
            <div className="mb-4 md:mb-0 flex items-center" data-id="element-207">
              <Shield size={18} className="mr-2 text-[#D4AF37]" data-id="element-208" />
              <span className="mr-4" data-id="element-209">Licensed & Insured</span>
              <Award size={18} className="mr-2 text-[#D4AF37]" data-id="element-210" />
              <span data-id="element-211">Professional Certifications</span>
            </div>
            <div className="text-gray-400 text-sm" data-id="element-212">
              &copy; {new Date().getFullYear()} Crown Inspection Services. All
              rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>;
}